// import { countriesList } from '@/config/countriesList';
import { FormValidationErrors } from '@/interfaces/Form';
import * as Yup from 'yup';


const competitorValidationSchema = Yup.object().shape({
  Crew: Yup.string(),
  Name: Yup.string().trim(FormValidationErrors.WHITESPACES).strict(true).max(30, FormValidationErrors.MAX_LENGTH).required(FormValidationErrors.REQUIRED),
  Type: Yup.string().required(FormValidationErrors.REQUIRED),
  Email: Yup.string()
    .transform((v) => (v === '' ? undefined : v))
    .optional()
    .email(FormValidationErrors.INVALID_EMAIL),
});

export default competitorValidationSchema;